<form [formGroup]="fG">
  <ejs-multiselect
    #multiselect
    [formControlName]="fCN"
    [dataSource]="dataSource"
    [fields]="mapping"
    [mode]="mode"
    [selectAllText]="selectAllText"
    [unSelectAllText]="unSelectAllText"
    [showSelectAll]="showSelectAll"
    [placeholder]="placeholder"
    [cssClass]="cssClass + ' ' + (fG.controls[fCN].invalid && fG.controls[fCN].dirty ? 'e-error' : '')">
  </ejs-multiselect>
  @if (hasErrorField) {
    <div class="error-label" role="alert">
      {{ errorText && fG.controls[fCN].invalid && fG.controls[fCN].dirty ? errorText : '' }}
    </div>
  }
</form>
